module.exports = __webpack_public_path__ + "static/turtle-creek-house03-6d8d525e680edc67da6e8eff7ce0940c.jpg";